webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(67);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(165);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(69);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  store: _store2.default,
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Presence = exports.Ajax = exports.LongPoll = exports.Socket = exports.Channel = undefined;
	
	var _getOwnPropertyNames = __webpack_require__(79);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(80);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(88);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(85);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(86);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VSN = "1.0.0";
	var SOCKET_STATES = { connecting: 0, open: 1, closing: 2, closed: 3 };
	var DEFAULT_TIMEOUT = 10000;
	var CHANNEL_STATES = {
	  closed: "closed",
	  errored: "errored",
	  joined: "joined",
	  joining: "joining",
	  leaving: "leaving"
	};
	var CHANNEL_EVENTS = {
	  close: "phx_close",
	  error: "phx_error",
	  join: "phx_join",
	  reply: "phx_reply",
	  leave: "phx_leave"
	};
	var TRANSPORTS = {
	  longpoll: "longpoll",
	  websocket: "websocket"
	};
	
	var Push = function () {
	  function Push(channel, event, payload, timeout) {
	    (0, _classCallCheck3.default)(this, Push);
	
	    this.channel = channel;
	    this.event = event;
	    this.payload = payload || {};
	    this.receivedResp = null;
	    this.timeout = timeout;
	    this.timeoutTimer = null;
	    this.recHooks = [];
	    this.sent = false;
	  }
	
	  (0, _createClass3.default)(Push, [{
	    key: "resend",
	    value: function resend(timeout) {
	      this.timeout = timeout;
	      this.cancelRefEvent();
	      this.ref = null;
	      this.refEvent = null;
	      this.receivedResp = null;
	      this.sent = false;
	      this.send();
	    }
	  }, {
	    key: "send",
	    value: function send() {
	      if (this.hasReceived("timeout")) {
	        return;
	      }
	      this.startTimeout();
	      this.sent = true;
	      this.channel.socket.push({
	        topic: this.channel.topic,
	        event: this.event,
	        payload: this.payload,
	        ref: this.ref
	      });
	    }
	  }, {
	    key: "receive",
	    value: function receive(status, callback) {
	      if (this.hasReceived(status)) {
	        callback(this.receivedResp.response);
	      }
	
	      this.recHooks.push({ status: status, callback: callback });
	      return this;
	    }
	  }, {
	    key: "matchReceive",
	    value: function matchReceive(_ref) {
	      var status = _ref.status,
	          response = _ref.response,
	          ref = _ref.ref;
	
	      this.recHooks.filter(function (h) {
	        return h.status === status;
	      }).forEach(function (h) {
	        return h.callback(response);
	      });
	    }
	  }, {
	    key: "cancelRefEvent",
	    value: function cancelRefEvent() {
	      if (!this.refEvent) {
	        return;
	      }
	      this.channel.off(this.refEvent);
	    }
	  }, {
	    key: "cancelTimeout",
	    value: function cancelTimeout() {
	      clearTimeout(this.timeoutTimer);
	      this.timeoutTimer = null;
	    }
	  }, {
	    key: "startTimeout",
	    value: function startTimeout() {
	      var _this = this;
	
	      if (this.timeoutTimer) {
	        return;
	      }
	      this.ref = this.channel.socket.makeRef();
	      this.refEvent = this.channel.replyEventName(this.ref);
	
	      this.channel.on(this.refEvent, function (payload) {
	        _this.cancelRefEvent();
	        _this.cancelTimeout();
	        _this.receivedResp = payload;
	        _this.matchReceive(payload);
	      });
	
	      this.timeoutTimer = setTimeout(function () {
	        _this.trigger("timeout", {});
	      }, this.timeout);
	    }
	  }, {
	    key: "hasReceived",
	    value: function hasReceived(status) {
	      return this.receivedResp && this.receivedResp.status === status;
	    }
	  }, {
	    key: "trigger",
	    value: function trigger(status, response) {
	      this.channel.trigger(this.refEvent, { status: status, response: response });
	    }
	  }]);
	  return Push;
	}();
	
	var Channel = exports.Channel = function () {
	  function Channel(topic, params, socket) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, Channel);
	
	    this.state = CHANNEL_STATES.closed;
	    this.topic = topic;
	    this.params = params || {};
	    this.socket = socket;
	    this.bindings = [];
	    this.timeout = this.socket.timeout;
	    this.joinedOnce = false;
	    this.joinPush = new Push(this, CHANNEL_EVENTS.join, this.params, this.timeout);
	    this.pushBuffer = [];
	    this.rejoinTimer = new Timer(function () {
	      return _this2.rejoinUntilConnected();
	    }, this.socket.reconnectAfterMs);
	    this.joinPush.receive("ok", function () {
	      _this2.state = CHANNEL_STATES.joined;
	      _this2.rejoinTimer.reset();
	      _this2.pushBuffer.forEach(function (pushEvent) {
	        return pushEvent.send();
	      });
	      _this2.pushBuffer = [];
	    });
	    this.onClose(function () {
	      _this2.rejoinTimer.reset();
	      _this2.socket.log("channel", "close " + _this2.topic + " " + _this2.joinRef());
	      _this2.state = CHANNEL_STATES.closed;
	      _this2.socket.remove(_this2);
	    });
	    this.onError(function (reason) {
	      if (_this2.isLeaving() || _this2.isClosed()) {
	        return;
	      }
	      _this2.socket.log("channel", "error " + _this2.topic, reason);
	      _this2.state = CHANNEL_STATES.errored;
	      _this2.rejoinTimer.scheduleTimeout();
	    });
	    this.joinPush.receive("timeout", function () {
	      if (!_this2.isJoining()) {
	        return;
	      }
	      _this2.socket.log("channel", "timeout " + _this2.topic, _this2.joinPush.timeout);
	      _this2.state = CHANNEL_STATES.errored;
	      _this2.rejoinTimer.scheduleTimeout();
	    });
	    this.on(CHANNEL_EVENTS.reply, function (payload, ref) {
	      _this2.trigger(_this2.replyEventName(ref), payload);
	    });
	  }
	
	  (0, _createClass3.default)(Channel, [{
	    key: "rejoinUntilConnected",
	    value: function rejoinUntilConnected() {
	      this.rejoinTimer.scheduleTimeout();
	      if (this.socket.isConnected()) {
	        this.rejoin();
	      }
	    }
	  }, {
	    key: "join",
	    value: function join() {
	      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;
	
	      if (this.joinedOnce) {
	        throw "tried to join multiple times. 'join' can only be called a single time per channel instance";
	      } else {
	        this.joinedOnce = true;
	        this.rejoin(timeout);
	        return this.joinPush;
	      }
	    }
	  }, {
	    key: "onClose",
	    value: function onClose(callback) {
	      this.on(CHANNEL_EVENTS.close, callback);
	    }
	  }, {
	    key: "onError",
	    value: function onError(callback) {
	      this.on(CHANNEL_EVENTS.error, function (reason) {
	        return callback(reason);
	      });
	    }
	  }, {
	    key: "on",
	    value: function on(event, callback) {
	      this.bindings.push({ event: event, callback: callback });
	    }
	  }, {
	    key: "off",
	    value: function off(event) {
	      this.bindings = this.bindings.filter(function (bind) {
	        return bind.event !== event;
	      });
	    }
	  }, {
	    key: "canPush",
	    value: function canPush() {
	      return this.socket.isConnected() && this.isJoined();
	    }
	  }, {
	    key: "push",
	    value: function push(event, payload) {
	      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.timeout;
	
	      if (!this.joinedOnce) {
	        throw "tried to push '" + event + "' to '" + this.topic + "' before joining. Use channel.join() before pushing events";
	      }
	      var pushEvent = new Push(this, event, payload, timeout);
	      if (this.canPush()) {
	        pushEvent.send();
	      } else {
	        pushEvent.startTimeout();
	        this.pushBuffer.push(pushEvent);
	      }
	
	      return pushEvent;
	    }
	  }, {
	    key: "leave",
	    value: function leave() {
	      var _this3 = this;
	
	      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;
	
	      this.state = CHANNEL_STATES.leaving;
	      var onClose = function onClose() {
	        _this3.socket.log("channel", "leave " + _this3.topic);
	        _this3.trigger(CHANNEL_EVENTS.close, "leave", _this3.joinRef());
	      };
	      var leavePush = new Push(this, CHANNEL_EVENTS.leave, {}, timeout);
	      leavePush.receive("ok", function () {
	        return onClose();
	      }).receive("timeout", function () {
	        return onClose();
	      });
	      leavePush.send();
	      if (!this.canPush()) {
	        leavePush.trigger("ok", {});
	      }
	
	      return leavePush;
	    }
	  }, {
	    key: "onMessage",
	    value: function onMessage(event, payload, ref) {
	      return payload;
	    }
	  }, {
	    key: "isMember",
	    value: function isMember(topic) {
	      return this.topic === topic;
	    }
	  }, {
	    key: "joinRef",
	    value: function joinRef() {
	      return this.joinPush.ref;
	    }
	  }, {
	    key: "sendJoin",
	    value: function sendJoin(timeout) {
	      this.state = CHANNEL_STATES.joining;
	      this.joinPush.resend(timeout);
	    }
	  }, {
	    key: "rejoin",
	    value: function rejoin() {
	      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;
	      if (this.isLeaving()) {
	        return;
	      }
	      this.sendJoin(timeout);
	    }
	  }, {
	    key: "trigger",
	    value: function trigger(event, payload, ref) {
	      var close = CHANNEL_EVENTS.close,
	          error = CHANNEL_EVENTS.error,
	          leave = CHANNEL_EVENTS.leave,
	          join = CHANNEL_EVENTS.join;
	
	      if (ref && [close, error, leave, join].indexOf(event) >= 0 && ref !== this.joinRef()) {
	        return;
	      }
	      var handledPayload = this.onMessage(event, payload, ref);
	      if (payload && !handledPayload) {
	        throw "channel onMessage callbacks must return the payload, modified or unmodified";
	      }
	
	      this.bindings.filter(function (bind) {
	        return bind.event === event;
	      }).map(function (bind) {
	        return bind.callback(handledPayload, ref);
	      });
	    }
	  }, {
	    key: "replyEventName",
	    value: function replyEventName(ref) {
	      return "chan_reply_" + ref;
	    }
	  }, {
	    key: "isClosed",
	    value: function isClosed() {
	      return this.state === CHANNEL_STATES.closed;
	    }
	  }, {
	    key: "isErrored",
	    value: function isErrored() {
	      return this.state === CHANNEL_STATES.errored;
	    }
	  }, {
	    key: "isJoined",
	    value: function isJoined() {
	      return this.state === CHANNEL_STATES.joined;
	    }
	  }, {
	    key: "isJoining",
	    value: function isJoining() {
	      return this.state === CHANNEL_STATES.joining;
	    }
	  }, {
	    key: "isLeaving",
	    value: function isLeaving() {
	      return this.state === CHANNEL_STATES.leaving;
	    }
	  }]);
	  return Channel;
	}();
	
	var Socket = exports.Socket = function () {
	  function Socket(endPoint) {
	    var _this4 = this;
	
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    (0, _classCallCheck3.default)(this, Socket);
	
	    this.stateChangeCallbacks = { open: [], close: [], error: [], message: [] };
	    this.channels = [];
	    this.sendBuffer = [];
	    this.ref = 0;
	    this.timeout = opts.timeout || DEFAULT_TIMEOUT;
	    this.transport = opts.transport || window.WebSocket || LongPoll;
	    this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 30000;
	    this.reconnectAfterMs = opts.reconnectAfterMs || function (tries) {
	      return [1000, 2000, 5000, 10000][tries - 1] || 10000;
	    };
	    this.logger = opts.logger || function () {};
	    this.longpollerTimeout = opts.longpollerTimeout || 20000;
	    this.params = opts.params || {};
	    this.endPoint = endPoint + "/" + TRANSPORTS.websocket;
	    this.reconnectTimer = new Timer(function () {
	      _this4.disconnect(function () {
	        return _this4.connect();
	      });
	    }, this.reconnectAfterMs);
	  }
	
	  (0, _createClass3.default)(Socket, [{
	    key: "protocol",
	    value: function protocol() {
	      return location.protocol.match(/^https/) ? "wss" : "ws";
	    }
	  }, {
	    key: "endPointURL",
	    value: function endPointURL() {
	      var uri = Ajax.appendParams(Ajax.appendParams(this.endPoint, this.params), { vsn: VSN });
	      if (uri.charAt(0) !== "/") {
	        return uri;
	      }
	      if (uri.charAt(1) === "/") {
	        return this.protocol() + ":" + uri;
	      }
	
	      return this.protocol() + "://" + location.host + uri;
	    }
	  }, {
	    key: "disconnect",
	    value: function disconnect(callback, code, reason) {
	      if (this.conn) {
	        this.conn.onclose = function () {};
	        if (code) {
	          this.conn.close(code, reason || "");
	        } else {
	          this.conn.close();
	        }
	        this.conn = null;
	      }
	      callback && callback();
	    }
	  }, {
	    key: "connect",
	    value: function connect(params) {
	      var _this5 = this;
	
	      if (params) {
	        console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
	        this.params = params;
	      }
	      if (this.conn) {
	        return;
	      }
	
	      this.conn = new this.transport(this.endPointURL());
	      this.conn.timeout = this.longpollerTimeout;
	      this.conn.onopen = function () {
	        return _this5.onConnOpen();
	      };
	      this.conn.onerror = function (error) {
	        return _this5.onConnError(error);
	      };
	      this.conn.onmessage = function (event) {
	        return _this5.onConnMessage(event);
	      };
	      this.conn.onclose = function (event) {
	        return _this5.onConnClose(event);
	      };
	    }
	  }, {
	    key: "log",
	    value: function log(kind, msg, data) {
	      this.logger(kind, msg, data);
	    }
	  }, {
	    key: "onOpen",
	    value: function onOpen(callback) {
	      this.stateChangeCallbacks.open.push(callback);
	    }
	  }, {
	    key: "onClose",
	    value: function onClose(callback) {
	      this.stateChangeCallbacks.close.push(callback);
	    }
	  }, {
	    key: "onError",
	    value: function onError(callback) {
	      this.stateChangeCallbacks.error.push(callback);
	    }
	  }, {
	    key: "onMessage",
	    value: function onMessage(callback) {
	      this.stateChangeCallbacks.message.push(callback);
	    }
	  }, {
	    key: "onConnOpen",
	    value: function onConnOpen() {
	      var _this6 = this;
	
	      this.log("transport", "connected to " + this.endPointURL(), this.transport.prototype);
	      this.flushSendBuffer();
	      this.reconnectTimer.reset();
	      if (!this.conn.skipHeartbeat) {
	        clearInterval(this.heartbeatTimer);
	        this.heartbeatTimer = setInterval(function () {
	          return _this6.sendHeartbeat();
	        }, this.heartbeatIntervalMs);
	      }
	      this.stateChangeCallbacks.open.forEach(function (callback) {
	        return callback();
	      });
	    }
	  }, {
	    key: "onConnClose",
	    value: function onConnClose(event) {
	      this.log("transport", "close", event);
	      this.triggerChanError();
	      clearInterval(this.heartbeatTimer);
	      this.reconnectTimer.scheduleTimeout();
	      this.stateChangeCallbacks.close.forEach(function (callback) {
	        return callback(event);
	      });
	    }
	  }, {
	    key: "onConnError",
	    value: function onConnError(error) {
	      this.log("transport", error);
	      this.triggerChanError();
	      this.stateChangeCallbacks.error.forEach(function (callback) {
	        return callback(error);
	      });
	    }
	  }, {
	    key: "triggerChanError",
	    value: function triggerChanError() {
	      this.channels.forEach(function (channel) {
	        return channel.trigger(CHANNEL_EVENTS.error);
	      });
	    }
	  }, {
	    key: "connectionState",
	    value: function connectionState() {
	      switch (this.conn && this.conn.readyState) {
	        case SOCKET_STATES.connecting:
	          return "connecting";
	        case SOCKET_STATES.open:
	          return "open";
	        case SOCKET_STATES.closing:
	          return "closing";
	        default:
	          return "closed";
	      }
	    }
	  }, {
	    key: "isConnected",
	    value: function isConnected() {
	      return this.connectionState() === "open";
	    }
	  }, {
	    key: "remove",
	    value: function remove(channel) {
	      this.channels = this.channels.filter(function (c) {
	        return c.joinRef() !== channel.joinRef();
	      });
	    }
	  }, {
	    key: "channel",
	    value: function channel(topic) {
	      var chanParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var chan = new Channel(topic, chanParams, this);
	      this.channels.push(chan);
	      return chan;
	    }
	  }, {
	    key: "push",
	    value: function push(data) {
	      var _this7 = this;
	
	      var topic = data.topic,
	          event = data.event,
	          payload = data.payload,
	          ref = data.ref;
	
	      var callback = function callback() {
	        return _this7.conn.send((0, _stringify2.default)(data));
	      };
	      this.log("push", topic + " " + event + " (" + ref + ")", payload);
	      if (this.isConnected()) {
	        callback();
	      } else {
	        this.sendBuffer.push(callback);
	      }
	    }
	  }, {
	    key: "makeRef",
	    value: function makeRef() {
	      var newRef = this.ref + 1;
	      if (newRef === this.ref) {
	        this.ref = 0;
	      } else {
	        this.ref = newRef;
	      }
	
	      return this.ref.toString();
	    }
	  }, {
	    key: "sendHeartbeat",
	    value: function sendHeartbeat() {
	      if (!this.isConnected()) {
	        return;
	      }
	      this.push({ topic: "phoenix", event: "heartbeat", payload: {}, ref: this.makeRef() });
	    }
	  }, {
	    key: "flushSendBuffer",
	    value: function flushSendBuffer() {
	      if (this.isConnected() && this.sendBuffer.length > 0) {
	        this.sendBuffer.forEach(function (callback) {
	          return callback();
	        });
	        this.sendBuffer = [];
	      }
	    }
	  }, {
	    key: "onConnMessage",
	    value: function onConnMessage(rawMessage) {
	      var msg = JSON.parse(rawMessage.data);
	      var topic = msg.topic,
	          event = msg.event,
	          payload = msg.payload,
	          ref = msg.ref;
	
	      this.log("receive", (payload.status || "") + " " + topic + " " + event + " " + (ref && "(" + ref + ")" || ""), payload);
	      this.channels.filter(function (channel) {
	        return channel.isMember(topic);
	      }).forEach(function (channel) {
	        return channel.trigger(event, payload, ref);
	      });
	      this.stateChangeCallbacks.message.forEach(function (callback) {
	        return callback(msg);
	      });
	    }
	  }]);
	  return Socket;
	}();
	
	var LongPoll = exports.LongPoll = function () {
	  function LongPoll(endPoint) {
	    (0, _classCallCheck3.default)(this, LongPoll);
	
	    this.endPoint = null;
	    this.token = null;
	    this.skipHeartbeat = true;
	    this.onopen = function () {};
	    this.onerror = function () {};
	    this.onmessage = function () {};
	    this.onclose = function () {};
	    this.pollEndpoint = this.normalizeEndpoint(endPoint);
	    this.readyState = SOCKET_STATES.connecting;
	
	    this.poll();
	  }
	
	  (0, _createClass3.default)(LongPoll, [{
	    key: "normalizeEndpoint",
	    value: function normalizeEndpoint(endPoint) {
	      return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)\/" + TRANSPORTS.websocket), "$1/" + TRANSPORTS.longpoll);
	    }
	  }, {
	    key: "endpointURL",
	    value: function endpointURL() {
	      return Ajax.appendParams(this.pollEndpoint, { token: this.token });
	    }
	  }, {
	    key: "closeAndRetry",
	    value: function closeAndRetry() {
	      this.close();
	      this.readyState = SOCKET_STATES.connecting;
	    }
	  }, {
	    key: "ontimeout",
	    value: function ontimeout() {
	      this.onerror("timeout");
	      this.closeAndRetry();
	    }
	  }, {
	    key: "poll",
	    value: function poll() {
	      var _this8 = this;
	
	      if (!(this.readyState === SOCKET_STATES.open || this.readyState === SOCKET_STATES.connecting)) {
	        return;
	      }
	
	      Ajax.request("GET", this.endpointURL(), "application/json", null, this.timeout, this.ontimeout.bind(this), function (resp) {
	        if (resp) {
	          var status = resp.status,
	              token = resp.token,
	              messages = resp.messages;
	
	          _this8.token = token;
	        } else {
	          var status = 0;
	        }
	
	        switch (status) {
	          case 200:
	            messages.forEach(function (msg) {
	              return _this8.onmessage({ data: (0, _stringify2.default)(msg) });
	            });
	            _this8.poll();
	            break;
	          case 204:
	            _this8.poll();
	            break;
	          case 410:
	            _this8.readyState = SOCKET_STATES.open;
	            _this8.onopen();
	            _this8.poll();
	            break;
	          case 0:
	          case 500:
	            _this8.onerror();
	            _this8.closeAndRetry();
	            break;
	          default:
	            throw "unhandled poll status " + status;
	        }
	      });
	    }
	  }, {
	    key: "send",
	    value: function send(body) {
	      var _this9 = this;
	
	      Ajax.request("POST", this.endpointURL(), "application/json", body, this.timeout, this.onerror.bind(this, "timeout"), function (resp) {
	        if (!resp || resp.status !== 200) {
	          _this9.onerror(status);
	          _this9.closeAndRetry();
	        }
	      });
	    }
	  }, {
	    key: "close",
	    value: function close(code, reason) {
	      this.readyState = SOCKET_STATES.closed;
	      this.onclose();
	    }
	  }]);
	  return LongPoll;
	}();
	
	var Ajax = exports.Ajax = function () {
	  function Ajax() {
	    (0, _classCallCheck3.default)(this, Ajax);
	  }
	
	  (0, _createClass3.default)(Ajax, null, [{
	    key: "request",
	    value: function request(method, endPoint, accept, body, timeout, ontimeout, callback) {
	      if (window.XDomainRequest) {
	        var req = new XDomainRequest();
	        this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
	      } else {
	        var _req = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	        this.xhrRequest(_req, method, endPoint, accept, body, timeout, ontimeout, callback);
	      }
	    }
	  }, {
	    key: "xdomainRequest",
	    value: function xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
	      var _this10 = this;
	
	      req.timeout = timeout;
	      req.open(method, endPoint);
	      req.onload = function () {
	        var response = _this10.parseJSON(req.responseText);
	        callback && callback(response);
	      };
	      if (ontimeout) {
	        req.ontimeout = ontimeout;
	      }
	
	      req.onprogress = function () {};
	
	      req.send(body);
	    }
	  }, {
	    key: "xhrRequest",
	    value: function xhrRequest(req, method, endPoint, accept, body, timeout, ontimeout, callback) {
	      var _this11 = this;
	
	      req.timeout = timeout;
	      req.open(method, endPoint, true);
	      req.setRequestHeader("Content-Type", accept);
	      req.onerror = function () {
	        callback && callback(null);
	      };
	      req.onreadystatechange = function () {
	        if (req.readyState === _this11.states.complete && callback) {
	          var response = _this11.parseJSON(req.responseText);
	          callback(response);
	        }
	      };
	      if (ontimeout) {
	        req.ontimeout = ontimeout;
	      }
	
	      req.send(body);
	    }
	  }, {
	    key: "parseJSON",
	    value: function parseJSON(resp) {
	      return resp && resp !== "" ? JSON.parse(resp) : null;
	    }
	  }, {
	    key: "serialize",
	    value: function serialize(obj, parentKey) {
	      var queryStr = [];
	      for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	          continue;
	        }
	        var paramKey = parentKey ? parentKey + "[" + key + "]" : key;
	        var paramVal = obj[key];
	        if ((typeof paramVal === "undefined" ? "undefined" : (0, _typeof3.default)(paramVal)) === "object") {
	          queryStr.push(this.serialize(paramVal, paramKey));
	        } else {
	          queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
	        }
	      }
	      return queryStr.join("&");
	    }
	  }, {
	    key: "appendParams",
	    value: function appendParams(url, params) {
	      if ((0, _keys2.default)(params).length === 0) {
	        return url;
	      }
	
	      var prefix = url.match(/\?/) ? "&" : "?";
	      return "" + url + prefix + this.serialize(params);
	    }
	  }]);
	  return Ajax;
	}();
	
	Ajax.states = { complete: 4 };
	
	var Presence = exports.Presence = {
	  syncState: function syncState(currentState, newState, onJoin, onLeave) {
	    var _this12 = this;
	
	    var state = this.clone(currentState);
	    var joins = {};
	    var leaves = {};
	
	    this.map(state, function (key, presence) {
	      if (!newState[key]) {
	        leaves[key] = presence;
	      }
	    });
	    this.map(newState, function (key, newPresence) {
	      var currentPresence = state[key];
	      if (currentPresence) {
	        var newRefs = newPresence.metas.map(function (m) {
	          return m.phx_ref;
	        });
	        var curRefs = currentPresence.metas.map(function (m) {
	          return m.phx_ref;
	        });
	        var joinedMetas = newPresence.metas.filter(function (m) {
	          return curRefs.indexOf(m.phx_ref) < 0;
	        });
	        var leftMetas = currentPresence.metas.filter(function (m) {
	          return newRefs.indexOf(m.phx_ref) < 0;
	        });
	        if (joinedMetas.length > 0) {
	          joins[key] = newPresence;
	          joins[key].metas = joinedMetas;
	        }
	        if (leftMetas.length > 0) {
	          leaves[key] = _this12.clone(currentPresence);
	          leaves[key].metas = leftMetas;
	        }
	      } else {
	        joins[key] = newPresence;
	      }
	    });
	    return this.syncDiff(state, { joins: joins, leaves: leaves }, onJoin, onLeave);
	  },
	  syncDiff: function syncDiff(currentState, _ref2, onJoin, onLeave) {
	    var joins = _ref2.joins,
	        leaves = _ref2.leaves;
	
	    var state = this.clone(currentState);
	    if (!onJoin) {
	      onJoin = function onJoin() {};
	    }
	    if (!onLeave) {
	      onLeave = function onLeave() {};
	    }
	
	    this.map(joins, function (key, newPresence) {
	      var currentPresence = state[key];
	      state[key] = newPresence;
	      if (currentPresence) {
	        var _state$key$metas;
	
	        (_state$key$metas = state[key].metas).unshift.apply(_state$key$metas, (0, _toConsumableArray3.default)(currentPresence.metas));
	      }
	      onJoin(key, currentPresence, newPresence);
	    });
	    this.map(leaves, function (key, leftPresence) {
	      var currentPresence = state[key];
	      if (!currentPresence) {
	        return;
	      }
	      var refsToRemove = leftPresence.metas.map(function (m) {
	        return m.phx_ref;
	      });
	      currentPresence.metas = currentPresence.metas.filter(function (p) {
	        return refsToRemove.indexOf(p.phx_ref) < 0;
	      });
	      onLeave(key, currentPresence, leftPresence);
	      if (currentPresence.metas.length === 0) {
	        delete state[key];
	      }
	    });
	    return state;
	  },
	  list: function list(presences, chooser) {
	    if (!chooser) {
	      chooser = function chooser(key, pres) {
	        return pres;
	      };
	    }
	
	    return this.map(presences, function (key, presence) {
	      return chooser(key, presence);
	    });
	  },
	  map: function map(obj, func) {
	    return (0, _getOwnPropertyNames2.default)(obj).map(function (key) {
	      return func(key, obj[key]);
	    });
	  },
	  clone: function clone(obj) {
	    return JSON.parse((0, _stringify2.default)(obj));
	  }
	};
	
	var Timer = function () {
	  function Timer(callback, timerCalc) {
	    (0, _classCallCheck3.default)(this, Timer);
	
	    this.callback = callback;
	    this.timerCalc = timerCalc;
	    this.timer = null;
	    this.tries = 0;
	  }
	
	  (0, _createClass3.default)(Timer, [{
	    key: "reset",
	    value: function reset() {
	      this.tries = 0;
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "scheduleTimeout",
	    value: function scheduleTimeout() {
	      var _this13 = this;
	
	      clearTimeout(this.timer);
	
	      this.timer = setTimeout(function () {
	        _this13.tries = _this13.tries + 1;
	        _this13.callback();
	      }, this.timerCalc(this.tries + 1));
	    }
	  }]);
	  return Timer;
	}();

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.roomIdFromHref = roomIdFromHref;
	exports.openSocket = openSocket;
	exports.prepareChannel = prepareChannel;
	
	var _phoenix = __webpack_require__(45);
	
	var _jsSha = __webpack_require__(160);
	
	var _jsSha2 = _interopRequireDefault(_jsSha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function roomIdFromHref() {
	  var regexArr = window.location.href.match(/.*:\/\/.*.*\/#*(.+)/);
	  return regexArr ? regexArr[1] : null;
	}
	
	function openSocket() {
	  var socket = new _phoenix.Socket(("wss://ws.1op.eu/socket"));
	  socket.connect();
	  return socket;
	}
	
	function prepareChannel(_ref) {
	  var socket = _ref.socket,
	      roomId = _ref.roomId,
	      password = _ref.password,
	      encryptedRsaPub = _ref.encryptedRsaPub;
	
	  return socket.channel('room:' + roomId, {
	    params: {
	      sha512: (0, _jsSha2.default)(password),
	      rsa_pub: encryptedRsaPub
	    } });
	}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(89);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(84);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vue = __webpack_require__(67);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(23);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueResource = __webpack_require__(175);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _jsencrypt = __webpack_require__(161);
	
	var _phoenix = __webpack_require__(45);
	
	var _cryptoJs = __webpack_require__(134);
	
	var _helpers = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  password: '',
	  error: '',
	  authorized: false,
	  allowEntranceSubmit: true,
	  room_id: (0, _helpers.roomIdFromHref)(),
	  initialWindowTitle: document.title,
	  messages: [],
	  users: [],
	  presence: {}
	};
	
	var mutations = {
	  SAVE_CREDENTIALS: function SAVE_CREDENTIALS(state, data) {
	    state.authorized = true;
	    state.room_id = data.room_id;
	    state.password = data.password;
	  },
	  REMOVE_ERROR: function REMOVE_ERROR(state) {
	    state.error = '';
	  },
	  DISCONNECTED: function DISCONNECTED(state) {
	    var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'something went wrong...';
	
	    state.error = reason;
	    state.authorized = false;
	    state.password = '';
	  },
	  SAVE_CHANNEL: function SAVE_CHANNEL(state, channel) {
	    state.channel = channel;
	  },
	  SAVE_RSA: function SAVE_RSA(state, rsa) {
	    state.rsa = rsa;
	  },
	  RECEIVE_MESSAGE: function RECEIVE_MESSAGE(state, message) {
	    state.messages.push({
	      user_color: message.body[0],
	      body: state.rsa.decrypt(message.body[1]),
	      date: new Date()
	    });
	  },
	  UPDATE_PRESENCE: function UPDATE_PRESENCE(state, presence) {
	    state.presence = presence;
	  },
	  UPDATE_USERS: function UPDATE_USERS(state, users) {
	    state.users = users.map(function (el) {
	      return {
	        user_color: el.user_color,
	        rsa_pub: _cryptoJs.AES.decrypt(el.rsa_pub, state.password).toString(_cryptoJs.enc.Utf8)
	      };
	    });
	  },
	  ALLOW_SUBMIT_ENTRANCE: function ALLOW_SUBMIT_ENTRANCE(state) {
	    state.allowEntranceSubmit = true;
	  },
	  BLOCK_SUBMIT_ENTRANCE: function BLOCK_SUBMIT_ENTRANCE(state) {
	    state.allowEntranceSubmit = false;
	  },
	  WINDOW_FOCUSED: function WINDOW_FOCUSED(state, boolean) {
	    state.windowFocused = boolean;
	  }
	};
	
	var actions = {
	  REQUEST_ENTRANCE: function REQUEST_ENTRANCE(_ref, data) {
	    var dispatch = _ref.dispatch,
	        commit = _ref.commit;
	
	    var socket = (0, _helpers.openSocket)();
	    socket.onError(function () {
	      commit('DISCONNECTED');
	      commit('ALLOW_SUBMIT_ENTRANCE');
	    });
	
	    socket.onOpen(function () {
	      var rsa = new _jsencrypt.JSEncrypt({ default_key_size: 2048 });
	      commit('SAVE_RSA', rsa);
	
	      var encryptedRsaPub = _cryptoJs.AES.encrypt(rsa.getPublicKey(), data.password).toString();
	
	      var channel = (0, _helpers.prepareChannel)({
	        socket: socket,
	        encryptedRsaPub: encryptedRsaPub,
	        roomId: data.room_id,
	        password: data.password
	      });
	
	      channel.join().receive('ok', function () {
	        commit('REMOVE_ERROR');
	        commit('ALLOW_SUBMIT_ENTRANCE');
	        commit('SAVE_CREDENTIALS', data);
	        commit('SAVE_CHANNEL', channel);
	
	        dispatch('HOOK_CHANNEL', channel);
	        dispatch('HOOK_BODY_FOCUS_ACTIONS');
	        dispatch('SYNC_HREF_WITH_ROOM_ID');
	      }).receive('error', function (res) {
	        commit('DISCONNECTED', res['reason']);
	        commit('ALLOW_SUBMIT_ENTRANCE');
	      });
	    });
	  },
	  HOOK_CHANNEL: function HOOK_CHANNEL(_ref2, channel) {
	    var state = _ref2.state,
	        dispatch = _ref2.dispatch,
	        commit = _ref2.commit;
	
	    channel.on('new_msg', function (payload) {
	      commit('RECEIVE_MESSAGE', payload);
	      dispatch('NOTIFY_USER_IF_NECCESSARY');
	      dispatch('SCROLL_TO_BOTTOM');
	    });
	
	    channel.on('presence_state', function (initial) {
	      dispatch('UPDATE_PRESENCE', _phoenix.Presence.syncState(state.presence, initial));
	    });
	
	    channel.on('presence_diff', function (diff) {
	      dispatch('UPDATE_PRESENCE', _phoenix.Presence.syncDiff(state.presence, diff));
	    });
	  },
	  UPDATE_PRESENCE: function UPDATE_PRESENCE(_ref3, presence) {
	    var commit = _ref3.commit;
	
	    commit('UPDATE_PRESENCE', presence);
	    if ((presence[''] || {}).metas) {
	      commit('UPDATE_USERS', presence[''].metas);
	    }
	  },
	  SYNC_HREF_WITH_ROOM_ID: function SYNC_HREF_WITH_ROOM_ID(_ref4) {
	    var state = _ref4.state;
	
	    if (state.room_id !== (0, _helpers.roomIdFromHref)()) {
	      window.location.hash = state.room_id;
	    }
	  },
	  SEND_MESSAGE: function SEND_MESSAGE(_ref5, message) {
	    var state = _ref5.state,
	        commit = _ref5.commit;
	
	    var encMessage = state.users.map(function (user) {
	      var encrypt = new _jsencrypt.JSEncrypt();
	      encrypt.setPublicKey(user.rsa_pub);
	
	      return [user.user_color, encrypt.encrypt(message)];
	    });
	
	    state.channel.push('new_msg', { body: encMessage });
	  },
	  SUBMIT_ENTRANCE_REQUEST: function SUBMIT_ENTRANCE_REQUEST(_ref6, form) {
	    var _this = this;
	
	    var dispatch = _ref6.dispatch,
	        commit = _ref6.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return dispatch('REQUEST_ENTRANCE', {
	                room_id: (form.roomIdField || {}).value || (0, _helpers.roomIdFromHref)(),
	                password: form.passwordField.value
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  BLOCK_SUBMIT_ENTRANCE: function BLOCK_SUBMIT_ENTRANCE(_ref7) {
	    var commit = _ref7.commit;
	
	    commit('BLOCK_SUBMIT_ENTRANCE');
	  },
	  SCROLL_TO_BOTTOM: function SCROLL_TO_BOTTOM() {
	    window.scrollTo(0, document.body.scrollHeight);
	  },
	  HOOK_BODY_FOCUS_ACTIONS: function HOOK_BODY_FOCUS_ACTIONS(_ref8) {
	    var state = _ref8.state,
	        commit = _ref8.commit;
	
	    window.addEventListener('blur', function () {
	      return commit('WINDOW_FOCUSED', false);
	    });
	    window.addEventListener('focus', function () {
	      document.title = state.initialWindowTitle;
	      commit('WINDOW_FOCUSED', true);
	    });
	  },
	  NOTIFY_USER_IF_NECCESSARY: function NOTIFY_USER_IF_NECCESSARY(_ref9) {
	    var state = _ref9.state;
	
	    if (state.windowFocused === false) {
	      document.title = '(*) ' + state.initialWindowTitle;
	    }
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions
	});

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Logo = __webpack_require__(169);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Loading = __webpack_require__(168);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Entrance = __webpack_require__(167);
	
	var _Entrance2 = _interopRequireDefault(_Entrance);
	
	var _Chat = __webpack_require__(166);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _vuex = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: { Entrance: _Entrance2.default, Logo: _Logo2.default, Chat: _Chat2.default, Loading: _Loading2.default },
	  computed: (0, _vuex.mapState)(['authorized', 'allowEntranceSubmit'])
	};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'chat',
	  data: function data() {
	    return { newMessage: '' };
	  },
	
	  computed: (0, _vuex.mapState)({
	    messages: 'messages',
	    users: 'users'
	  }),
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['SEND_MESSAGE']), {
	    parseColor: function parseColor(color) {
	      var bigint = parseInt(color, 16);
	      var r = bigint >> 16 & 255;
	      var g = bigint >> 8 & 255;
	      var b = bigint & 255;
	
	      return {
	        'border-color': '#' + color,
	        'background-color': 'rgba(' + r + ', ' + g + ', ' + b + ', 0.1)'
	      };
	    },
	    parseTime: function parseTime(date) {
	      var hours = date.getHours();
	      var minutes = date.getMinutes();
	      return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
	    },
	    sendMessage: function sendMessage() {
	      this.SEND_MESSAGE(this.newMessage);
	      this.newMessage = '';
	    }
	  })
	};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'entrance',
	  computed: (0, _vuex.mapState)(['room_id', 'allowEntranceSubmit']),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['SUBMIT_ENTRANCE_REQUEST', 'BLOCK_SUBMIT_ENTRANCE']), {
	    submitEntranceRequest: function submitEntranceRequest(target) {
	      var _this = this;
	
	      this.BLOCK_SUBMIT_ENTRANCE();
	      setTimeout(function () {
	        _this.SUBMIT_ENTRANCE_REQUEST(target);
	      }, 100);
	    }
	  })
	};

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Loading'
	};

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(23);
	
	exports.default = {
	  name: 'logo',
	  computed: (0, _vuex.mapState)(['error'])
	};

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(155)
	
	/* script */
	__vue_exports__ = __webpack_require__(70)
	
	/* template */
	var __vue_template__ = __webpack_require__(170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(159)
	
	/* script */
	__vue_exports__ = __webpack_require__(71)
	
	/* template */
	var __vue_template__ = __webpack_require__(174)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-841ffed4"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(158)
	
	/* script */
	__vue_exports__ = __webpack_require__(72)
	
	/* template */
	var __vue_template__ = __webpack_require__(173)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-80355418"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(157)
	
	/* script */
	__vue_exports__ = __webpack_require__(73)
	
	/* template */
	var __vue_template__ = __webpack_require__(172)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6a4bb524"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(156)
	
	/* script */
	__vue_exports__ = __webpack_require__(74)
	
	/* template */
	var __vue_template__ = __webpack_require__(171)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3dc65d2e"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('logo'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(!_vm.allowEntranceSubmit) ? _c('loading') : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(!_vm.authorized) ? _c('entrance', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.allowEntranceSubmit),
	      expression: "allowEntranceSubmit"
	    }]
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.authorized) ? _c('chat') : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "bigAndBold"
	  }, [_c('span', {
	    staticClass: "grey"
	  }, [_vm._v(" / ")]), _vm._v("1op.eu "), _c('span', {
	    staticClass: "grey"
	  }, [_vm._v(" / ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('b', [_vm._v("Extremely")]), _vm._v(" private way to send your messages and passwords in realtime. Fully encrypted using "), _c('b', [_vm._v("RSA-2048")]), _vm._v(" for messages and "), _c('b', [_vm._v("AES-256")]), _vm._v(" to transmit their public keys.")])
	}]}

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "loading"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/loader.gif"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Generating your RSA key...")])])
	}]}

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "entrance"
	  }, [_c('br'), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submitEntranceRequest($event.target)
	      }
	    }
	  }, [_c('fieldset', [(!_vm.room_id) ? _c('span', [_c('label', {
	    attrs: {
	      "for": "r"
	    }
	  }, [_vm._v("Your desired room id ( 1op.eu/... )")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "disabled": !_vm.allowEntranceSubmit,
	      "name": "roomIdField",
	      "id": "r",
	      "type": "text",
	      "placeholder": "room id, eg. asdasdasd"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "p"
	    }
	  }, [_vm._v("Your secret password (it will get lost if you refresh the site*)")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "disabled": !_vm.allowEntranceSubmit,
	      "name": "passwordField",
	      "id": "p",
	      "type": "password",
	      "placeholder": "Enter your password..."
	    }
	  }), _vm._v(" "), _c('small', [_vm._v(" * - so don't hit refresh after entering the chatroom ")]), _vm._v(" "), _c('center', [_c('input', {
	    attrs: {
	      "disabled": !_vm.allowEntranceSubmit,
	      "type": "submit"
	    }
	  })])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', [_vm._v("What the hell is this place?")]), _vm._v(" "), _c('p', [_vm._v("\n    1op is an encrypted chat application, where I try to solve a couple of trust-related problems when it comes to current instant chat apps. Let's dive deeper into how this idea is structured...\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Alright, so what's the big deal?")]), _vm._v(" "), _c('p', [_vm._v("\n    We can pretty much encrypt stuff using either symmetric or asymmetric algorithms. With symmetric encryption we only need a key passphrase to encrypt/decrypt a message. It's all more complicated when it comes to asymmetric encryption algorithms, where we have a Private and a Public key. Using a Private key we can encrypt a message, which can be decrypted using only the Public one, and vice-versa (Public-key-encrypted messages can be decrypted using only the Private key). That's pretty much how the Internet identity trust is built. We trust that Google is Google, because its identity is encrypted using some Certificate Authority's Private Key (which is securely stored somewhere far away) and we all have its Public key stored on our computers. We could use the same solution in instant messaging in order to prevent everybody inbetween our computers from seeing our messages.\n  ")]), _vm._v(" "), _c('p', [_vm._v("... but why shouldn't we?")]), _vm._v(" "), _c('p', [_vm._v("\n    The Internet relies on certificates, which are signed by authorities, in which indentities we all trust. In order to gain that kind of signed certificate we have to pay a price to a Certificate Authority and we won't be doing this for a simple chatroom. The only solution we have is to generate our own certificates. But we have to transfer them somehow between computers, and that is where a rogue middleman can come in to interfere. It's very easy for the middleman to fake secure connection when we rely only on an asymmetrical encryption protocol like RSA (the middleman can store our public key, generate its own key-pair and encrypt every message using its own key, and then resend a message encrypted by our own public key back to us without anyone noticing). What's the solution I would like to offer?\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Let's encrypt public keys using symmetric encryption!")]), _vm._v(" "), _c('p', [_vm._v("\n    There is a splendid symmetric encryption protocol called AES, which we can use to encrypt our public key before sending it to our chatroom friend. AES needs a passphrase. A password, which we can tell each other using other type of communication (e.g. mobile phone). That way, we can be sure that:\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("Whoa! How exactly does it work?")]), _vm._v(" "), _c('p', [_vm._v("\n  First of all you save your plain password in a browser temporarily (which will be cleared after a refresh, so don't do that). Then, you will send its SHA-512 hashsum (one-way encryption) to the server in order to compare with other chatroom members. If you are the first one or the previous guy had the same password-hashsum you will open a socket connection to the server and send your Public RSA key encrypted using AES using your password (stored temporarily in your browser). Every other chatroom client will receive your message and decrypt your RSA Public key using AES with the same password you got. From now on, you will receive messages encrypted on other clients' computers using your RSA Public key.\n  ")]), _vm._v(" "), _c('h5', [_vm._v("... but wait! How can i trust you?!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n  You just send a link and a password to a friend. You don't have to set up a chatroom before sending the link, so just write "), _c('em', [_vm._v("1op.eu/your_room")]), _vm._v(" and send it right away. If both of you have the same password, you will get connected and no one will ever see what you have been talking about. There is no limit when it comes to people connected to a chat room (they all have to know the firstly-connected user's password). You can share only text messages.\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', [_c('li', [_vm._v("No one inbetween our computers can read our messages in real time (which would be impossible without signing an asymmetrical key-pair or trusting a middleman)")]), _vm._v(" "), _c('li', [_vm._v("No one can ever decrypt our messages in the future, even when they have all our web traffic secured and know our initial passphrase (thanks to an asymmetrical encryption)")]), _vm._v(" "), _c('li', [_vm._v("1op.eu is 1op.eu (thanks to a certificate signed by \"Let's Encrypt\" Certificate Authority - take a look at the green lock or "), _c('em', [_vm._v("https://")]), _vm._v(" in the address bar).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("It's "), _c('a', {
	    attrs: {
	      "href": "http://github.com/intpl/1op-elixir-vuejs",
	      "target": "_blank"
	    }
	  }, [_vm._v("open source")]), _vm._v(", baby! I did it just for fun. You can read the code and set it up on your own if you are paranoid. :)")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('em', [_vm._v("Made with love by "), _c('a', {
	    attrs: {
	      "href": "http://gladecki.pl",
	      "target": "_blank"
	    }
	  }, [_vm._v("Bartek Gladecki")])])
	}]}

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row chat"
	  }, [(_vm.messages.length > 0) ? _c('div', {
	    staticClass: "column column-70"
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "list"
	    }
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('div', {
	      key: message,
	      staticClass: "message",
	      style: (_vm.parseColor(message.user_color))
	    }, [_c('div', {
	      staticClass: "time_block"
	    }, [_vm._v("\n            " + _vm._s(_vm.parseTime(message.date)) + "\n          ")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(message.body))])])
	  }))], 1) : _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.users.length == 1) ? _c('div', [_vm._v("\n        Invite somebody by sending them a link to this page. Remember to tell them what's the password. Otherwise, they won't be able to connect.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Keep in mind that users won't be able to see messeges sent while they were gone.\n      ")]) : _c('div', [_c('br'), _vm._v(" "), _c('b', [_vm._v("Oh! Somebody is here!")]), _vm._v(" Write something, quickly! :)\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "container footer"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "user_count"
	  }, [_vm._v("\n        users online: "), _c('b', [_vm._v(_vm._s(_vm.users.length))])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessage),
	      expression: "newMessage"
	    }],
	    attrs: {
	      "maxlength": "240",
	      "autofocus": "",
	      "placeholder": "(240 characters. Enter sends)",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newMessage)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
	        _vm.sendMessage($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessage = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.7dd1853561c46dd4198e.js